export default __webpack_public_path__ + "static/media/logo-white.44fa9118.png";